// extracted by mini-css-extract-plugin
module.exports = {"Chat":"Chat_Chat__2YXYA","Message":"Chat_Message__dvx3u"};